<app-header></app-header>
<div style="width: 94%; margin: 1% 3%">
  <router-outlet></router-outlet>
</div>
